import { InviteRequest } from "src/types/InviteRequest";
import SimpleTable from "./SimpleTable";
import InviteRequestTableRow from "./rows/InviteRequestTable.Row";
import usePageView from "../../hooks/usePageView";

interface Props {
  data: InviteRequest[];
  readOnly?: boolean;
}

const cols = ["", "name", "email", "phone", "desc"];

export function InviteRequestTable({ data, readOnly }: Props) {
usePageView("invite_request_list");
  return (
    <SimpleTable
      cols={cols}
      rows={data}
      section="inviteRequest"
      Row={InviteRequestTableRow}
      readOnly={readOnly}
    />
  );
}
